import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import SupplierCategory from '../models/SupplierCategory';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    supplierCategories: [],
    supplierCategoryAll: [],
    supplierCategoryDetail: new SupplierCategory()
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SUPPLIER_CATEGORY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_CATEGORY_LIST_SUCCESS:
            return {
                ...state, isFetching: false,
                supplierCategories: action.categories,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
            };

        case Types.SUPPLIER_CATEGORY_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_CATEGORY_LIST_ALL_SUCCESS:
            return { ...state, isFetching: false, supplierCategoryAll: action.categories };

        case Types.SUPPLIER_CATEGORY_GET_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_CATEGORY_GET_DETAIL_SUCCESS:
            return {
                ...state,
                isFetchingDetail: false,
                supplierCategoryDetail: action.category
            };

        case Types.SUPPLIER_CATEGORY_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_CATEGORY_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.SUPPLIER_CATEGORY_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_CATEGORY_DELETE_SUCCESS:
            return { ...state, isFetching: false };

        case Types.SUPPLIER_CATEGORY_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false };
        default:
            return state;
    }
}
